"use client";

import { Cta } from "@/sanity/sanity.types";
import Button, { ButtonStyle } from "../button/button";
import css from "./cash-out.module.scss";
import Link, { LinkType } from "../link/link";
import { useState } from "react";

interface ICashOutProps {
  title: string;
  buttonData: { text: string }[];
  className?: string;
  primaryCta?: Cta;
}

const CashOut = (props: ICashOutProps) => {
  const { title, buttonData, className, primaryCta } = props;
  const [selected, setSelected] = useState<number>(0);

  return (
    <div className={`${css.cashOut} ${className}`}>
      <h2 className={`${css.cashOutTitle} cashOutTitle`}>{title}</h2>
      <div className="flex flex-col gap-y-4 w-full">
        {buttonData.map((button, index) => (
          <Button
            key={index}
            style={ButtonStyle.Secondary}
            fullWidth
            onClick={() => setSelected(index)}
            active={selected === index}
            className="cashOutButton"
          >
            {button.text}
          </Button>
        ))}
      </div>
      <Link
        href={primaryCta?.link?.href ?? ""}
        linkType={LinkType.BUTTON}
        className="!w-full cashOutButton !border-[2px] !py-4"
      >
        {primaryCta?.link?.label ?? "Get Cash Out"}
      </Link>
    </div>
  );
};

export default CashOut;
